var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 234,
    height: 42,
    viewBox: "0 0 234 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_3669_41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.5 7.5C52.5 4.188 49.812 1.5 46.5 1.5H7.5C4.188 1.5 1.5 4.188 1.5 7.5V34.5C1.5 37.812 4.188 40.5 7.5 40.5H46.5C49.812 40.5 52.5 37.812 52.5 34.5V7.5Z",
    stroke: "#6784FF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M27 31.5C32.799 31.5 37.5 26.799 37.5 21C37.5 15.201 32.799 10.5 27 10.5C21.201 10.5 16.5 15.201 16.5 21C16.5 26.799 21.201 31.5 27 31.5Z",
    stroke: "#6784FF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M30 22.5H25.5V18",
    stroke: "#6784FF",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Chrono.tech"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M76.1823 31.8463C81.3815 31.8463 84.9834 28.9648 85.6724 24.2667H81.82C81.1936 26.8976 79.0951 28.495 76.1823 28.495C72.3612 28.495 69.9495 25.3942 69.9495 20.4143C69.9495 15.497 72.3925 12.3962 76.1823 12.3962C79.0325 12.3962 81.2876 14.2128 81.7887 16.969H85.6724C85.2026 12.2396 81.2876 9.04492 76.1823 9.04492C69.9182 9.04492 65.9092 13.3985 65.9092 20.4143C65.9092 27.524 69.8869 31.8463 76.1823 31.8463Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M87.9893 31.4707H91.779V21.9492C91.779 19.4436 93.4077 17.7836 95.8194 17.7836C98.1058 17.7836 99.5152 19.193 99.5152 21.5734V31.4707H103.305V20.7904C103.305 17.0006 100.925 14.5576 97.2601 14.5576C94.6919 14.5576 92.7813 15.6225 91.8104 17.6583H91.7477V8.38745H87.9893V31.4707Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M105.999 31.4707H109.789V21.7613C109.789 19.4123 111.136 17.9716 113.391 17.9716C113.892 17.9716 114.581 18.0655 114.894 18.1908V14.7142C114.612 14.6203 114.142 14.5576 113.735 14.5576C111.762 14.5576 110.259 15.7165 109.726 17.6584H109.632V14.7455H105.999V31.4707Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M123.221 31.7211C128.17 31.7211 131.271 28.4324 131.271 23.108C131.271 17.8148 128.139 14.5261 123.221 14.5261C118.335 14.5261 115.172 17.8148 115.172 23.108C115.172 28.4324 118.304 31.7211 123.221 31.7211ZM123.221 28.683C120.622 28.683 119.056 26.6159 119.056 23.108C119.056 19.6314 120.622 17.5642 123.221 17.5642C125.852 17.5642 127.418 19.6314 127.418 23.108C127.418 26.6159 125.852 28.683 123.221 28.683Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M133.339 31.4707H137.129V21.8866C137.129 19.4436 138.695 17.7836 141.044 17.7836C143.33 17.7836 144.614 19.1304 144.614 21.5108V31.4707H148.435V20.7591C148.435 16.9067 146.149 14.5576 142.453 14.5576C139.885 14.5576 138.068 15.6225 137.066 17.6584H136.972V14.7455H133.339V31.4707Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M158.437 31.7211C163.386 31.7211 166.486 28.4324 166.486 23.108C166.486 17.8148 163.354 14.5261 158.437 14.5261C153.551 14.5261 150.388 17.8148 150.388 23.108C150.388 28.4324 153.52 31.7211 158.437 31.7211ZM158.437 28.683C155.837 28.683 154.271 26.6159 154.271 23.108C154.271 19.6314 155.837 17.5642 158.437 17.5642C161.068 17.5642 162.634 19.6314 162.634 23.108C162.634 26.6159 161.068 28.683 158.437 28.683Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M170.528 31.6273C171.75 31.6273 172.721 30.6877 172.721 29.4349C172.721 28.2134 171.75 27.2424 170.528 27.2424C169.276 27.2424 168.305 28.2134 168.305 29.4349C168.305 30.6877 169.276 31.6273 170.528 31.6273Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M175.507 11.0181V14.7452H173.221V17.7207H175.507V27.0229C175.507 30.2489 176.917 31.533 180.456 31.533C181.27 31.533 182.053 31.4704 182.46 31.4077V28.4636C182.21 28.4949 181.709 28.5576 181.333 28.5576C179.955 28.5576 179.328 27.8998 179.328 26.5217V17.7207H182.492V14.7452H179.328V11.0181H175.507Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M191.523 17.5016C193.809 17.5016 195.344 19.0676 195.438 21.5106H187.514C187.67 19.0989 189.299 17.5016 191.523 17.5016ZM195.438 26.4906C194.999 27.8687 193.59 28.7457 191.742 28.7457C189.205 28.7457 187.482 26.9604 187.482 24.2668V24.0476H199.165V22.7947C199.165 17.7208 196.221 14.5261 191.523 14.5261C186.731 14.5261 183.661 17.9087 183.661 23.1706C183.661 28.4324 186.731 31.7211 191.679 31.7211C195.563 31.7211 198.538 29.5913 199.04 26.4906H195.438Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M215.873 20.665C215.623 17.2197 212.867 14.5261 208.513 14.5261C203.658 14.5261 200.526 17.8774 200.526 23.108C200.526 28.4324 203.69 31.7211 208.544 31.7211C212.71 31.7211 215.56 29.3094 215.905 25.6449H212.303C211.958 27.5555 210.612 28.6204 208.576 28.6204C206.07 28.6204 204.41 26.5845 204.41 23.108C204.41 19.7253 206.039 17.6269 208.544 17.6269C210.706 17.6269 212.021 18.911 212.272 20.665H215.873Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M217.887 31.4704H221.677V21.949C221.677 19.4434 223.305 17.7834 225.717 17.7834C228.003 17.7834 229.413 19.1928 229.413 21.5732V31.4704H233.202V20.7901C233.202 17.0004 230.822 14.5574 227.158 14.5574C224.589 14.5574 222.679 15.6223 221.708 17.6581H221.645V8.38721H217.887V31.4704Z",
    fill: "white"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3669_41"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 234,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo7);
export default __webpack_public_path__ + "static/media/logo7.6f1e38ffb5b4b6915a5034cc75f8f3eb.svg";
export { ForwardRef as ReactComponent };